var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section section-components"},[_c('div',{staticClass:"container"},[_c('tabs-section'),_c('images')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }